import { render, staticRenderFns } from "./AnjLicense.vue?vue&type=template&id=3d6450ba"
import script from "./AnjLicense.vue?vue&type=script&lang=js"
export * from "./AnjLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports